import { t } from "i18next";
import "../../Style/finish/finish.css";
import CustomButtonColor from "../../Components/custom-button/CustomButtonColor";
import LightModeOutlinedIcon from '@mui/icons-material/LightModeOutlined';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { navigateToNewTabExternal } from "../../Services/service";
import BannerAccept from '../../Assets/Images/Banner_Accept.jpg';
import BannerDecline from '../../Assets/Images/Banner_Decline.jpg';
import BannerAcceptMobile from '../../Assets/Images/Banner_Accept.jpeg';
import BannerDeclineMobile from '../../Assets/Images/Banner_Decline.jpeg';
import { useEffect, useState } from "react";

function FinishSection({objectDto, setObjectDto, setIsLoading}) {
    const handleClickSuccess = () => {
        setIsLoading(true);
        setObjectDto(undefined);
        window.scrollTo(0,0);
        setIsLoading(false);
        localStorage.clear();
    }
    const handleClickFail = () => {
        navigateToNewTabExternal(process.env.REACT_APP_HOME_URL);
        setObjectDto(undefined);
        localStorage.clear();
    }
    const [mobile, setMobile] = useState(false);
    useEffect(()=>{
        window.scrollTo(0,0);
        const pageWidth = document.documentElement.scrollWidth;
        if(pageWidth <= 768) setMobile(true);
        else setMobile(false);
    },[])
    return (
        <section className="finish">
        <div className="finish-wrapper">
            <div className="finish-banner">
                <img src={
                    objectDto === undefined || objectDto.confirm !== 1 || objectDto.id === undefined ? 
                    (mobile ? BannerDeclineMobile : BannerDecline) : (mobile ? BannerAcceptMobile : BannerAccept)} 
                    alt="Finish Banner" className="banner-img" />
            </div>
            {
                objectDto === undefined || objectDto.confirm !== 1 || objectDto.id === undefined ?
                (
                    <div className="finish-content">
                        
                        <h1 className="finish-h1"><InfoOutlinedIcon /> Thông báo</h1>
                        <p className="finish-p">
                            Cảm ơn bạn đã chọn tham gia sản phẩm và sử dụng dịch vụ của Phú Hưng Life. 
                            Với thông tin bạn cung cấp, chúng tôi rất tiếc chưa thể chấp nhận hồ sơ yêu cầu bảo hiểm ở thời điểm hiện tại. 
                            Bạn có thể liên hệ với chúng tôi qua Tổng đài 1900 886838 để biết thêm chi tiết.
                            <br />
                            Trân trọng !
                        </p>
                        <div className="finish-button-fail">
                            <CustomButtonColor borderColor={"#007AFF"} borderRadius={"5px"} bgColor={"#007AFF26"} color={"black"} title={t("seemoreproduct")} onClick={handleClickFail}/>
                        </div>
                    </div>
                )
                :
                (
                    <div className="finish-content">
                        <span className="finish-icon"><LightModeOutlinedIcon /></span>
                        <h1 className="finish-h1">Chúc mừng bạn đã nộp thành công Hồ Sơ Yêu Cầu Bảo Hiểm</h1>
                        <p className="finish-p">
                            Công ty Cổ phần Bảo hiểm Nhân thọ Phú Hưng xin cảm ơn bạn đã sử dụng
                            dịch vụ của chúng tôi. Chúng tôi sẽ thẩm định hồ sơ và phản hồi đến
                            bạn trong thời gian sớm nhất.
                            <br />
                            Trân trọng !
                        </p>
                        <div className="finish-button">
                            <CustomButtonColor bgColor={"#c4960c"} color={"#fff"} title={t("continue")} onClick={handleClickSuccess}/>
                        </div>
                    </div>
                )
            }
        </div>
        </section>
    );
}
export default FinishSection;
